import { render, staticRenderFns } from "./sendTemplateOnMail.vue?vue&type=template&id=5578b266&scoped=true"
import script from "./sendTemplateOnMail.vue?vue&type=script&lang=js"
export * from "./sendTemplateOnMail.vue?vue&type=script&lang=js"
import style1 from "./sendTemplateOnMail.vue?vue&type=style&index=1&id=5578b266&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5578b266",
  null
  
)

export default component.exports